import { render, staticRenderFns } from "./NavbarItems.vue?vue&type=template&id=5e1b6250&scoped=true&"
import script from "./NavbarItems.vue?vue&type=script&lang=js&"
export * from "./NavbarItems.vue?vue&type=script&lang=js&"
import style0 from "./NavbarItems.vue?vue&type=style&index=0&id=5e1b6250&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1b6250",
  null
  
)

export default component.exports